import { NetworkUserApi } from '@api';
import { networkUserTypes as actionTypes, userTypes as userActionTypes } from './types';

export const fetchNetworkUsers = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  NetworkUserApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const createNetworkUser = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.CREATE.LOADING,
  });

  NetworkUserApi.create({ networkUser: params })
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: response,
        method: 'prepend',
      });

      dispatch({
        type: actionTypes.CREATE.SUCCESS,
        payload: response,
        message: 'notify:general.save.success',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.CREATE.FAILURE,
        payload: { data: error.data },
        message: `notify:general.save.error.${error.status}`,
      });
    });
};

export const updateNetworkUser = (id, params) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE.LOADING,
  });

  NetworkUserApi.update(id, { networkUser: params })
    .then((response) => {
      dispatch({
        type: userActionTypes.CURRENT.HYDRATE,
        payload: response,
      });

      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: response,
        method: 'add',
      });

      dispatch({
        type: actionTypes.UPDATE.SUCCESS,
        payload: response,
        message: 'notify:general.save.success',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.UPDATE.FAILURE,
        payload: { data: error.data },
        message: `notify:general.save.error.${error.status}`,
      });
    });
};

export const deleteNetworkUser = (id) => (dispatch) => {
  dispatch({
    type: actionTypes.DELETE.LOADING,
  });

  NetworkUserApi.delete(id)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: { data: id },
        method: 'remove',
      });

      dispatch({
        type: actionTypes.DELETE.SUCCESS,
        payload: response,
        message: 'notify:general.delete.success',
      });
    })
    .catch(() => {
      dispatch({
        type: actionTypes.UPDATE.FAILURE,
        message: 'notify:general.delete.errror',
      });
    });
};
